// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueResource from "vue-resource";

import "babel-polyfill";

import iview from "iview";
import "iview/dist/styles/iview.css";

// import '../static/less/basic.less';
import "../static/less/base.less";
import "../static/less/datetimepicker.less";
import "../static/less/doubletimepicker.less";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { HappyScroll } from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
Vue.component("happy-scroll", HappyScroll);
Vue.use(HappyScroll);

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.config.debug = true; //开启错误提示

Vue.use(VueResource);
Vue.use(iview);

Vue.http.options.headers = {
  authentication: window.sessionStorage.getItem("authentication")
  // authentication: "51370399-93aa-4e14-baec-f92b17c7e2e1"
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  render: h => h(App),
  template: "<App/>",
  data: {
    monitorStationHub: new Vue(),
    sensorTypeHub: new Vue(),
    timeTypeHub: new Vue(),
    onlyMapHub: new Vue(),
    treeClickHub: new Vue(),
    navShowHub: new Vue(),
    navHideHub: new Vue(),
    modalHideHub: new Vue(),
    viewVideoHub: new Vue(),
    backVideoHub: new Vue(),
    backDetailHub: new Vue(),
    selectModelHub: new Vue(),
    reportHub: new Vue(),
    treeOnlineHub: new Vue(),
    loadingHub: new Vue()
  }
});



// WEBPACK FOOTER //
// ./src/main.js